import { apiClient } from "shared/api/client";

/** 팝업(popUps) 도메인 API. */
export const fetchPopups = async () => {
  // all=true: 관리자 목록은 예약/미게시/기간만료 팝업까지 전부 조회한다.
  // (미전송 시 서버 기본값 all=false → 공개용 active 팝업만 반환됨)
  const response = await apiClient.get("/popUps", { params: { all: true } });
  return response.data;
};

export const getPopup = async (id) => {
  const response = await apiClient.get(`/popUps/${id}`);
  return response.data;
};

export const createPopup = async (data) => {
  const response = await apiClient.post("/popUps", data);
  return response.data;
};

export const updatePopup = async (id, data) => {
  // 서버는 PATCH /api/popUps/{id}만 제공한다(PUT은 405).
  const response = await apiClient.patch(`/popUps/${id}`, data);
  return response.data;
};

export const deletePopup = async (id) => {
  await apiClient.delete(`/popUps/${id}`);
};
